import React from 'react';

import Form from "./Form";

export default function MakeForm(props){

  const submit = ({
        formattedDateTime,
        placeId,
        placeDesc,
        latitude,
        longitude,
        minute,
        hour,
        day,
        month,
        year,
        dontKnowTime,
    }) => {

    // translate these into the ruby params
    const chart = {
      place_id: placeId,
      formatted_place: placeDesc,
      formatted_date: formattedDateTime,
      latitude,
      longitude,
      minute,
      hour,
      day,
      // js month dates start at 0
      month:month+1,
      year,
      dont_know_time:dontKnowTime
    };

    const form = document.createElement('form');

    Object.entries(chart).forEach(([key,value])=>{
      const input = document.createElement('input');
      input.value = value;

      // format it as nested name for rails
      input.name = key;
      form.appendChild( input );
    })

    // see if they are on a landing page
    // NOTE: landing page path has to match product
    const path = window.location.pathname.split('/');
    const product = path.length > 1 ? path[1] : null;

    // this is from the URL of the landing page
    if( product === 'rings' ){
      form.action = '/shop/ring/brass/7'

    }else if( product === 'pendants' ){
      form.action = '/shop/pendant/brass/small'
    }else if( product === 'posters' ){
      form.action = '/shop/poster'
    }else{
      form.action = props.shopPath || '/shop/ring/brass/7'
    }

    document.body.appendChild(form);

    form.submit();
  };

  return <Form mapKey={GOOGLEMAPS_KEY} submit={submit}/>;
}
